import React from 'react';
import { Box } from '@chakra-ui/react';

export interface IProps {
  id?: string;
  alt?: string;
  isLogomark?: boolean;
}

export const EnrolyLogo = (props: IProps): React.ReactElement => {
  if (props.isLogomark) {
    return (
      <Box
        sx={{
          _dark: {
            '#logoborder': {
              display: 'initial',
            },
          },
        }}
      >
        <svg
          data-selector={props.id ?? 'enroly-logo'}
          aria-labelledby="enrolyLogo"
          role="img"
          height="42"
          viewBox="0 0 42 42"
          width="42"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title id="enrolyLogo">{props.alt ?? 'Enroly logo'}</title>

          <mask id="a" fill="#000" height="42" maskUnits="userSpaceOnUse" width="42" x="0" y="0">
            <path d="m0 0h42v42h-42z" fill="#fff" />
            <path d="m1 13c0-8 4-12 12-12h16c8 0 12 4 12 12v16c0 8-4 12-12 12h-16c-8 0-12-4-12-12z" fill="#000" />
          </mask>
          <path d="m1 13c0-8 4-12 12-12h16c8 0 12 4 12 12v16c0 8-4 12-12 12h-16c-8 0-12-4-12-12z" fill="#014" />
          <path
            id="logoborder"
            display="none"
            d="m1 13c0-8 4-12 12-12h16c8 0 12 4 12 12v16c0 8-4 12-12 12h-16c-8 0-12-4-12-12z"
            mask="url(#a)"
            stroke="#fff"
            strokeOpacity=".1"
            strokeWidth="2"
          />
          <path
            d="m21 7.66699c7.7333 0 13.333 5.59971 13.333 13.33301h-6.666c0-3.8667-2.8003-6.667-6.667-6.667s-6.667 2.8003-6.667 6.667c0 3.7458 2.628 6.4903 6.3076 6.6582l.3594.0088v6.666c-7.7333 0-13.33301-5.5997-13.33301-13.333s5.59971-13.33301 13.33301-13.33301z"
            fill="#0af"
          />

          <path
            d="m20.9999 14.3333c-3.8666 0-6.6666 2.8-6.6666 6.6666h13.3333c0-3.8666-2.8-6.6666-6.6667-6.6666z"
            fill="#fff"
          />
          <path d="m29.3333 24.3333c-2.9 0-5 2.1-5 5s2.1 5 5 5h5v-5c0-2.9-2.1-5-5-5z" fill="#fb0" />
        </svg>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        _dark: {
          '#logotype': {
            fill: '#fff',
          },
        },
      }}
    >
      <svg
        data-selector={props.id ?? 'enroly-logo'}
        aria-labelledby="enrolyLogo"
        role="img"
        height="40"
        width="140"
        viewBox="0 0 280 80"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title id="enrolyLogo">{props.alt ?? 'Enroly logo'}</title>

        <path d="m0 24c0-16 8-24 24-24h32c16 0 24 8 24 24v32c0 16-8 24-24 24h-32c-16 0-24-8-24-24z" fill="#014" />
        <path
          d="m40 13.333c15.4667 0 26.667 11.2003 26.667 26.667h-13.334c0-7.7333-5.5997-13.333-13.333-13.333s-13.333 5.5997-13.333 13.333 5.5997 13.333 13.333 13.333v13.334c-15.4667 0-26.667-11.2003-26.667-26.667s11.2003-26.667 26.667-26.667z"
          fill="#0af"
        />
        <path
          clipRule="evenodd"
          d="m40.0001 26.6667c-7.7334 0-13.3334 5.6-13.3334 13.3334h26.6667c0-7.7334-5.6-13.3334-13.3333-13.3334z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="m56.6667 46.6667c-5.8 0-10 4.2-10 10s4.2 10 10 10h.0377 9.9623v-9.9623c0-.0125 0-.0251 0-.0377 0-5.8-4.2-10-10-10z"
          fill="#fb0"
          fillRule="evenodd"
        />
        <g id="logotype" fill="#014">
          <path d="m233.134 10.9358h8.395v35.3865c0 3.0589 1.264 3.0589 5.456 3.0589v7.5482s-2.25.551-4.762.551c-3.133 0-5.362-1.1624-6.643-2.439s-2.446-3.5645-2.446-6.6037z" />
          <path
            clipRule="evenodd"
            d="m133.303 39.6153c0 1.1991-.081 2.2782-.242 3.2375h-24.478c.201 2.3982 1.047 4.2768 2.538 5.6357 1.491 1.359 3.324 2.0385 5.5 2.0385 3.143 0 5.379-1.339 6.709-4.017h9.127c-.967 3.1976-2.821 5.8356-5.561 7.914-2.74 2.0384-6.104 3.0577-10.094 3.0577-3.223 0-6.124-.6995-8.703-2.0984-2.538-1.4389-4.533-3.4574-5.984-6.0554-1.41-2.598-2.115-5.5957-2.115-8.9932 0-3.4373.705-6.455 2.115-9.0531 1.411-2.598 3.385-4.5965 5.924-5.9954 2.538-1.3989 5.459-2.0984 8.763-2.0984 3.184 0 6.024.6795 8.523 2.0385 2.538 1.3589 4.492 3.2974 5.862 5.8155 1.411 2.4781 2.116 5.336 2.116 8.5735zm-8.764-2.3982c-.04-2.1583-.826-3.877-2.357-5.1561-1.531-1.319-3.405-1.9784-5.621-1.9784-2.096 0-3.868.6395-5.319 1.9185-1.41 1.239-2.277 2.9777-2.599 5.216z"
            fillRule="evenodd"
          />
          <path d="m155.822 23.2478c3.989 0 7.213 1.259 9.671 3.7771 2.457 2.4781 3.686 5.9554 3.686 10.432v19.4852h-8.461v-18.346c0-2.638-.665-4.6565-1.995-6.0554-1.329-1.4389-3.143-2.1584-5.439-2.1584-2.337 0-4.191.7195-5.561 2.1584-1.33 1.3989-1.994 3.4174-1.994 6.0554v18.346h-8.462v-33.2147h8.462v4.1368c1.128-1.4389 2.558-2.558 4.291-3.3574 1.773-.8394 3.707-1.259 5.802-1.259z" />
          <path d="m186.331 24.7466c-1.733.9993-3.143 2.3782-4.231 4.1369v-5.1561h-8.462v33.2147h8.462v-16.5474c0-3.0777.665-5.236 1.994-6.4751 1.37-1.239 3.385-1.8586 6.044-1.8586h2.237v-8.8132c-2.257 0-4.272.4996-6.044 1.4988z" />
          <path
            clipRule="evenodd"
            d="m210.73 57.4817c-3.223 0-6.124-.6995-8.703-2.0984-2.579-1.4389-4.614-3.4574-6.105-6.0554-1.45-2.598-2.176-5.5957-2.176-8.9932 0-3.3974.746-6.3951 2.237-8.9931 1.531-2.598 3.606-4.5965 6.225-5.9954 2.619-1.4389 5.54-2.1584 8.764-2.1584 3.223 0 6.145.7195 8.764 2.1584 2.619 1.3989 4.674 3.3974 6.165 5.9954 1.531 2.598 2.296 5.5957 2.296 8.9931 0 3.3975-.785 6.3952-2.357 8.9932-1.531 2.598-3.626 4.6165-6.286 6.0554-2.619 1.3989-5.56 2.0984-8.824 2.0984zm0-7.3145c1.531 0 2.962-.3597 4.291-1.0791 1.37-.7595 2.458-1.8786 3.264-3.3575.806-1.4788 1.209-3.2775 1.209-5.3959 0-3.1576-.846-5.5757-2.538-7.2544-1.653-1.7187-3.687-2.5781-6.105-2.5781s-4.452.8594-6.104 2.5781c-1.612 1.6787-2.418 4.0968-2.418 7.2544s.786 5.5958 2.357 7.3145c1.612 1.6787 3.627 2.518 6.044 2.518z"
            fillRule="evenodd"
          />
          <path d="m280 23.6093v29.6146c0 5.9155-1.03 10.1289-3.975 13.0067-2.946 2.8778-7.042 4.5-12.658 4.5-2.984 0-5.812-.3797-8.482-1.1391-2.632-.7594-4.974-2.1072-6.781-3.5461l3.776-6.4663c1.336 1.1192 2.965 1.9985 4.89 2.638 1.924.6395 3.868.9593 5.832.9593 3.063 0 5.301-.7195 6.715-2.1584s2.408-3.2492 2.408-6.5949v-1.3341c-1.178 1.199-2.597 2.391-4.207 3.0305s-3.12 1.1021-5.281 1.1021c-2.78 0-7.06-1.9106-9.495-4.3088-2.435-2.4382-3.947-5.5244-3.947-10.3607v-18.9427h8.29v17.5638c0 5.236 2.768 7.854 7.048 7.854 2.199 0 3.967-.7195 5.302-2.1584 1.335-1.4788 2.29-3.6572 2.29-6.535v-16.7244z" />
        </g>
      </svg>
    </Box>
  );
};
